<template>
  <v-form>
    <v-row justify="center">
      <v-col cols="12" sm="9" xl="4">
        <div class="cropper-wrapper">
          <PhotoCropper
            ref="cropper"
            :imageUrl="imageUrl"
            :imageLoader="imageLoader"
            header-tooltip="message.posts.addImageTooltip"
            @upload-image="uploadImage"
            @delete="handleDeleteImage"
          />
        </div>

        <v-textarea
          name="text"
          v-model="form.text"
          counter="1500"
          v-validate="'required|max:1500'"
          :data-vv-name="$t('message.posts.postName')"
          :error-messages="errors.collect($t('message.posts.postName'))"
          :label="`${$t('message.posts.postName')} *`"
          required
          rows="2"
          auto-grow
        ></v-textarea>
        <v-select
          :label="$t('message.posts.callToAction.label')"
          :items="[
            { name: $t('message.common.none'), value: 0 },
            ...callToActionItems
          ]"
          v-model="form.call_to_action.type"
          item-text="name"
          item-value="value"
        />

        <v-text-field
          v-if="form.call_to_action.type && form.call_to_action.type !== 6"
          name="url"
          v-model="form.call_to_action.url"
          v-validate="'required|url'"
          :data-vv-name="$t('message.posts.postUrl')"
          :error-messages="errors.collect($t('message.posts.postUrl'))"
          :label="`${$t('message.posts.postUrl')} *`"
          required
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row justify="center">
      <v-col cols="12" sm="9" xl="4">
        <PublicationDatePicker
          v-if="canPlanMarketingPublications"
          :type="type"
          :options="PUBLICATION_DATE_OPTIONS"
          :title="$t('message.posts.planning.publication.publicationDateTitle')"
          :subtitle="
            $t('message.posts.planning.publication.publicationDateSubtitle')
          "
          :edit-mode="editMode"
          :publish-at="form.publish_at"
          @change="handlePublicationDateChange"
        />
      </v-col>
    </v-row>
    <v-row justify="center" class="mt-4" no-gutters>
      <Footer>
        <ui-button
          color="primary"
          class="mr-8"
          @click="submit"
          :disabled="btnsDisabled"
        >
          {{ buttonLabel }}
        </ui-button>
        <ui-button
          outlined
          color="primary"
          icon="icon-search"
          :disabled="btnsDisabled"
          @click="showPreview()"
        >
          {{ $t("message.posts.preview") }}
        </ui-button>
      </Footer>
    </v-row>
  </v-form>
</template>

<script>
import { debounce } from "@/helpers/helpers";

import PhotoCropper from "@/components/Photos/Cropper.vue";
import { postFormMixin } from "@/helpers/mixins/post-form";

export default {
  name: "PostsPostForm",

  model: {
    event: "setForm"
  },

  mixins: [postFormMixin],

  props: {
    imageLoader: {
      type: Boolean,
      required: true
    },
    imageUrl: {
      type: String,
      required: false
    },
    value: { type: Object },
    editMode: {
      default: false,
      type: Boolean
    }
  },

  data() {
    return {
      form: null
    };
  },

  components: { PhotoCropper },

  computed: {
    btnsDisabled() {
      const editMode = this.$refs.cropper ? this.$refs.cropper.editMode : false;
      return this.imageLoader || editMode;
    }
  },

  created() {
    this.resetForm();
    if (this.$route.query.type === "fb" && this.$store.state.posts.fbPostData) {
      this.form.text = this.$store.state.posts.fbPostData.message;
    }
  },

  watch: {
    form: {
      handler: debounce(function(val) {
        this.setForm(val);
      }, 500),
      deep: true
    },
    "form.call_to_action.type": function(val) {
      if (!val || val === 6) {
        this.form.call_to_action.url = null;
      }
    }
  },
  methods: {
    setForm(val) {
      this.$emit("setForm", val);
    },

    resetForm() {
      this.form = this.value.id
        ? this.setFormPreset(this.value)
        : {
            text: null,
            call_to_action: {
              type: null,
              url: null
            },
            publish_at: null
          };
    }
  },
  beforeDestroy() {
    this.$store.dispatch("posts/clearFbPostData");
  }
};
</script>

<style lang="scss" scoped>
.upload {
  position: relative;

  width: 100%;
  padding-top: 75%;
  margin-bottom: $spacing * 6;

  &__image-label {
    cursor: pointer;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border: 3px dashed $primary;
    position: absolute;
    top: 0;
    left: 0;
    color: $primary;
    width: 100%;
    height: 100%;
    border-radius: 5px;
    font-weight: bold;
    background-size: cover;
    background-position: center center;

    i {
      @include font-size(58px);
      margin-bottom: $spacing * 1.25;
    }
  }
}

.info-icon {
  position: absolute;
  top: $spacing * -4;
  right: 0;
}

.cropper-wrapper {
  width: 100%;
  min-height: 250px;
  display: flex;
}
</style>
